import React from "react";
import { InsWidgetTitle } from "../../base";
import { InsMasterDetailChart } from "../insMasterDetailChart/insMasterDetailChart";
import { InsChartFactory } from "./insChartFactory";
import { InsChartSelector } from "./insChartSelector";
import { InsChartSettings } from "./insChartSettings";
import { InsWidget } from "components";
import { useIsTenorSettingsAvailable, useIsTimePeriodAvailable, useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { ChartSelectSlotProps } from "store/current-dashboard/types";
import preqinIcon from "../../icons/preqin.svg";
import { InsWidgetFooter } from "components/widgets/base/insWidgetFooter";
const showPersonalSettings = (settings, isTimePeriodAvailable, isTenorSettingsAvailable) => {
    if (!settings || Object.keys(settings).length === 0) {
        return isTimePeriodAvailable || isTenorSettingsAvailable;
    }
    const keys = Object.keys(settings);
    if (keys.length === 1 && settings.areDateSettingsAvailable !== undefined) {
        return settings.areDateSettingsAvailable || isTenorSettingsAvailable;
    }
    return true;
};
const iconMap = { preqin: preqinIcon };
export const InsChartWidget = (props) => {
    const { sectionId, widgetId } = props, { forceMarginOnContent, childrenId, userSettings, titleIcon, footer, description } = useWidgetComponentProps(sectionId, widgetId);
    const isTimePeriodAvailable = useIsTimePeriodAvailable(sectionId, widgetId);
    const isTenorSettingsAvailable = useIsTenorSettingsAvailable(sectionId, widgetId);
    const resolvedIcon = titleIcon && iconMap[titleIcon] ? iconMap[titleIcon] : titleIcon;
    // Render footer: optional icon, hyperlink that opens in a new tab, and date text
    const footerNode = React.createElement(InsWidgetFooter, { ...props, explicitFooter: footer });
    // Create title element in a stable variable to help shallow comparison in tests
    const titleElement = resolvedIcon
        ? React.createElement(InsWidgetTitle, { ...props, titleIcon: resolvedIcon })
        : React.createElement(InsWidgetTitle, { ...props });
    return React.createElement(InsWidget, { noMarginOnContent: !forceMarginOnContent, showMaximize: true, ...props, description: description, content: childrenId
            ? React.createElement(InsMasterDetailChart, { ...props })
            : React.createElement("span", { className: "insChartWidget__chartFactory" },
                React.createElement(InsChartFactory, { ...props })), headerLeft: React.createElement(InsChartSelector, { ...props, slot: ChartSelectSlotProps.left }), headerRight: React.createElement(InsChartSelector, { ...props, slot: ChartSelectSlotProps.right }), settingsContent: showPersonalSettings(userSettings, isTimePeriodAvailable, isTenorSettingsAvailable) ? React.createElement(InsChartSettings, { ...props }) : undefined, title: titleElement, footer: footerNode });
};
